import { useCallback } from 'react'
import { waitForTransactionReceipt } from 'utils/safe-tx'
import { Address, PublicClient, TransactionReceipt } from 'viem'

import { useConnection } from './useConnection'

type WaitForTransactionReceiptArgs = Parameters<PublicClient['waitForTransactionReceipt']>[0] & {
  address?: Address
}

/**
 * React hook wrapper for transaction receipt waiting.
 * Automatically handles both EOA and Safe (multisig) wallets.
 * For Safe wallets, resolves safeTxHash to the actual on-chain transaction hash.
 */
export function useWaitForTransactionReceipt() {
  const { wagmiPublicClient, account } = useConnection()

  return useCallback(
    async ({ hash, confirmations = 1, address }: WaitForTransactionReceiptArgs): Promise<TransactionReceipt> => {
      if (!wagmiPublicClient) {
        throw new Error('Public client is not available')
      }

      return waitForTransactionReceipt(wagmiPublicClient, {
        hash,
        confirmations,
        address: address ?? account,
      })
    },
    [wagmiPublicClient, account]
  )
}

export default useWaitForTransactionReceipt
